import angular from 'angular';

angular.module('cloudX').directive('multiCompanyOnly', [
  'dataCache',
  function(dataCache) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        const companies = dataCache.getArray('company');
        if (!companies || companies.length <= 1) element.remove();
      },
    };
  },
]);
